import { Howl, Howler } from 'howler';
import { makeCreatePlayer } from './makeCreatePlayer';

const createPlayer = makeCreatePlayer({ Howl, Howler });

export { createPlayer };
